var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-bubble-report-chart"},[_c('BubbleReportChartWrapper',{key:"bubblereport",attrs:{"chart-data":_vm.conformChartData,"benchmark":_vm.benchmark},on:{"click":_vm.onBubbleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }